<div *ngIf="vehicles">
    <p-table
        [paginator]="true"
        [value]="vehicles"
        [rows]="9"
        [rowsPerPageOptions]="[10, 15, 20]"
        responsiveLayout="scroll"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>{{ "VRN" | translate }}</th>
                <th>{{ "VEHICLE_MAKE" | translate }}</th>
                <th>{{ "MODEL" | translate }}</th>
                <th>{{ "WEIGHT_CATEGORY" | translate }}</th>
                <th>{{ "ENGINE_CAPACITY" | translate }}</th>
                <th>{{ "CARRYING_CAPACITY" | translate }}</th>
                <th>{{ "VEHICLE_USAGE" | translate }}</th>
                <th>{{ "STATUS" | translate }}</th>
                <th>{{ "ACTIONS" | translate }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vehicle>
            <tr>
                <td>
                    <span class="p-column-title">VRN</span>
                    {{
                        vehicle.registrationNumber
                            ? vehicle.registrationNumber
                            : "---"
                    }}
                </td>
                <td>
                    <span class="p-column-title">Vehicle Make</span>
                    {{ vehicle.model.make ? vehicle.model.make.name : "---" }}
                </td>
                <td>
                    <span class="p-column-title">Vehicle Model</span>
                    {{ vehicle.model.name ? vehicle.model.name : "---" }}
                </td>
                <td>
                    <span class="p-column-title">Weight Category</span>
                    {{
                        vehicle.weightCategory.name
                            ? (vehicle.weightCategory.name | translate)
                            : "---"
                    }}
                </td>
                <td>
                    <span class="p-column-title">Engine Capacity</span>
                    {{
                        vehicle.engineCapacity ? vehicle.engineCapacity : "---"
                    }}
                </td>
                <td>
                    <span class="p-column-title">Carrying Capacity</span>
                    {{
                        vehicle.carryingCapacity
                            ? vehicle.carryingCapacity
                                  .toString()
                                  .concat(" ")
                                  .concat("Seater" | translate)
                            : "---"
                    }}
                </td>
                <td>
                    <span class="p-column-title">Vehicle Usage</span>
                    {{
                        vehicle.vehicleUse.name
                            ? (formatText(vehicle.vehicleUse.name) | translate)
                            : "---"
                    }}
                </td>
                <td>
                    <span class="p-column-title">Status</span>
                    {{ vehicle.status ? (vehicle.status | translate) : "---" }}
                </td>
                <td>
                    <p-button
                        class="table-button"
                        [pTooltip]="'VIEW_VEHICLE_DETAILS' | translate"
                        icon="pi pi-info-circle"
                        [rounded]="true"
                        (onClick)="viewVehicleDetailClicked(vehicle.id)"
                        [text]="true"
                        severity="info"
                    />
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<ng-template #noVehicles>
    <div class="flex align-items-center">
        <i class="pi pi-exclamation-triangle mr-2"></i
        ><span>{{ "NO_VEHICLES" | translate }}</span>
    </div>
</ng-template>
